export const BrandsByCode = [
  { code: 'AC', name: 'Acura' },
  { code: 'AR', name: 'Alfa Romeo' },
  { code: 'AM', name: 'Astonmartin' },
  { code: 'AU', name: 'Audi' },
  { code: 'BE', name: 'Bentley' },
  { code: 'BM', name: 'BMW' },
  { code: 'BU', name: 'Buick' },
  { code: 'CA', name: 'Cadillac' },
  { code: 'CH', name: 'Chevrolet' },
  { code: 'CR', name: 'Chrysler' },
  { code: 'DO', name: 'Dodge' },
  { code: 'FE', name: 'Ferrari' },
  { code: 'FD', name: 'Ford' },
  { code: 'FO', name: 'Ford' },
  { code: 'GM', name: 'GMC' },
  { code: 'HD', name: 'Honda' },
  { code: 'HU', name: 'Hummer' },
  { code: 'HY', name: 'Hyundai' },
  { code: 'IN', name: 'INFINITI' },
  { code: 'JA', name: 'Jaguar' },
  { code: 'JE', name: 'Jeep' },
  { code: 'KI', name: 'Kia' },
  { code: 'LR', name: 'Land Rover' },
  { code: 'LE', name: 'Lexus' },
  { code: 'LI', name: 'Lincoln' },
  { code: 'MA', name: 'Maserati' },
  { code: 'MZ', name: 'Mazda' },
  { code: 'MB', name: 'Mercedes-Benz' },
  { code: 'ME', name: 'Mercury' },
  { code: 'MI', name: 'MINI' },
  { code: 'MT', name: 'Mitsubishi' },
  { code: 'NI', name: 'Nissan' },
  { code: 'OL', name: 'Oldsmobile' },
  { code: 'PO', name: 'Pontiac' },
  { code: 'PL', name: 'Plymouth' },
  { code: 'PR', name: 'Porsche' },
  { code: 'RA', name: 'Ram' },
  { code: 'SA', name: 'Saab' },
  { code: 'ST', name: 'Saturn' },
  { code: 'SC', name: 'Scion' },
  { code: 'SM', name: 'Smart' },
  { code: 'SU', name: 'Subaru' },
  { code: 'SZ', name: 'Suzuki' },
  { code: 'TO', name: 'Toyota' },
  { code: 'VW', name: 'Volkswagen' },
  { code: 'VO', name: 'Volvo' },
  { code: 'GE', name: 'Genesis' },
  { code: 'OB', name: 'Off-Brand' },
];

export const BrandsById = [
  { id: 1, name: 'Acura' },
  { id: 2, name: 'Astonmartin' },
  { id: 3, name: 'Audi' },
  { id: 4, name: 'Bentley' },
  { id: 5, name: 'BMW' },
  { id: 6, name: 'Buick' },
  { id: 7, name: 'Cadillac' },
  { id: 8, name: 'Chevrolet' },
  { id: 9, name: 'Chrysler' },
  { id: 10, name: 'Dodge' },
  { id: 11, name: 'Ferrari' },
  { id: 12, name: 'Ford' },
  { id: 13, name: 'GMC' },
  { id: 14, name: 'Honda' },
  { id: 15, name: 'Hummer' },
  { id: 16, name: 'Hyundai' },
  { id: 17, name: 'INFINITI' },
  { id: 18, name: 'Jaguar' },
  { id: 19, name: 'Jeep' },
  { id: 20, name: 'Kia' },
  { id: 21, name: 'Land Rover' },
  { id: 22, name: 'Lexus' },
  { id: 23, name: 'Lincoln' },
  { id: 24, name: 'Maserati' },
  { id: 25, name: 'Mazda' },
  { id: 26, name: 'Mercedes-Benz' },
  { id: 27, name: 'Mercury' },
  { id: 28, name: 'MINI' },
  { id: 29, name: 'Mitsubishi' },
  { id: 30, name: 'Nissan' },
  { id: 31, name: 'Oldsmobile' },
  { id: 32, name: 'Pontiac' },
  { id: 33, name: 'Plymouth' },
  { id: 34, name: 'Porsche' },
  { id: 35, name: 'Ram' },
  { id: 36, name: 'Saab' },
  { id: 37, name: 'Saturn' },
  { id: 38, name: 'Scion' },
  { id: 39, name: 'Smart' },
  { id: 40, name: 'Subaru' },
  { id: 41, name: 'Suzuki' },
  { id: 42, name: 'Toyota' },
  { id: 43, name: 'Volkswagen' },
  { id: 44, name: 'Volvo' },
  { id: 45, name: 'Genesis' },
  { id: 46, name: 'Off-Brand' },
  { id: 47, name: 'Alfa Romeo' },
];
